import { ROUTES } from 'routes/routes';

export let licenseDetailBackContext: Array<{ url: string; label: string }> = [
    { url: ROUTES.LICENSE_LIST, label: 'Licenses' },
];

export function setLicenseDetailBackContext(context: Array<{ url: string; label: string }>) {
    licenseDetailBackContext = context;
}
